export const SalesTransactionsData = [
  {
    id: '1',
    customer1: {
      name: 'John Smith',
      image: '/assets/img/customer/user-01.jpg',
      email: 'johnsmith@example.com',
    },
    customer2: {
      name: 'Robert',
      image: '/assets/img/customer/user-04.jpg',
      email: 'robert@example.com',
    },
    service: {
      image: '/assets/img/services/service-03.jpg',
      name: 'Computer Repair',
    },
    price: '$80',
    discount: '$4',
    tax: '$2',
    date: '28 Sep 2023',
    payment_method: 'Paypal',
    status: {
      text: 'Successful',
      badgeClass: 'badge-active',
    },
  },
  {
    id: '2',
    customer1: {
      name: 'Johnny',
      image: '/assets/img/customer/user-04.jpg',
      email: 'johnny@example.com',
    },
    customer2: {
      name: 'Pricilla',
      image: '/assets/img/customer/user-05.jpg',
      email: 'pricilla@example.com',
    },
    service: {
      image: '/assets/img/services/service-02.jpg',
      name: 'Car Repair Services',
    },
    price: '$100',
    discount: '$10',
    tax: '$3',
    date: '27 Sep 2023',
    payment_method: 'Paypal',
    status: {
      text: 'Refund',
      badgeClass: 'badge-delete',
    },
  },
  {
    id: '3',
    customer1: {
      name: 'Robert',
      image: '/assets/img/customer/user-06.jpg',
      email: 'robert@example.com',
    },
    customer2: {
      name: 'Amanda',
      image: '/assets/img/customer/user-02.jpg',
      email: 'amanda@example.com',
    },
    service: {
      image: '/assets/img/services/service-04.jpg',
      name: 'Steam Car Wash',
    },
    price: '$70',
    discount: '$30',
    tax: '$20',
    date: '27 Sep 2023',
    payment_method: 'Paypal',
    status: {
      text: 'Successful',
      badgeClass: 'badge-active',
    },
  },
  {
    id: '4',
    customer1: {
      name: 'Sharonda',
      image: '/assets/img/customer/user-09.jpg',
      email: 'sharonda@example.com',
    },
    customer2: {
      name: 'James',
      image: '/assets/img/customer/user-01.jpg',
      email: 'james@example.com',
    },
    service: {
      image: '/assets/img/services/service-09.jpg',
      name: 'House Cleaning',
    },
    price: '$150',
    discount: '$12',
    tax: '$4',
    date: '22 Sep 2023',
    payment_method: 'Paypal',
    status: {
      text: 'Refund',
      badgeClass: 'badge-delete',
    },
  },
  {
    id: '5',
    customer1: {
      name: 'John Smith',
      image: '/assets/img/customer/user-01.jpg',
      email: 'johnsmith@example.com',
    },
    customer2: {
      name: 'Sharon',
      image: '/assets/img/customer/user-03.jpg',
      email: 'sharon@example.com',
    },
    service: {
      image: '/assets/img/services/service-03.jpg',
      name: 'Computer Repair',
    },
    price: '$100',
    discount: '$10',
    tax: '$3',
    date: '27 Sep 2023',
    payment_method: 'Paypal',
    status: {
      text: 'Refund',
      badgeClass: 'badge-delete',
    },
  },
];
